import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { useParams, Link } from "react-router-dom";
import LeadsStatisticsTwo from "../widgetsStatistics/LeadsStatisticsTwo";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const TestTypeHeader = () => {
  const { slug } = useParams();
  const [myPermissions, setMyPermissions] = useState([]);

  // Dil ve çeviriler
  const userLanguage = useUserLanguage();
  const { translations: trans } = useTranslations(userLanguage);
  const getText = (key, defaultValue) => trans[key] || defaultValue;

  // Permissions çek
  useEffect(() => {
    fetchMyPermissions();
  }, []);

  const fetchMyPermissions = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!resp.data || !Array.isArray(resp.data.permissions)) {
        console.error("⚠️ API yanlış veri döndürdü:", resp.data);
        setMyPermissions([]);
      } else {
        setMyPermissions(resp.data.permissions);
      }
    } catch (error) {
      console.error("❌ Permission bilgileri çekilemedi:", error);
      setMyPermissions([]);
    }
  };

  // TestType modülü permission kontrolü (örneğin module_key: "test_type")
  const modulePerm = myPermissions.find(p => p.module_key === "static_admin_account");
  const canCreate = modulePerm?.create_permission || modulePerm?.full_access;

  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
        { (
          <Link to={`/test-types/create`} className="btn btn-primary">
            <FiPlus size={16} className="me-2" />
            <span>{getText("TEST_TYPE_CREATE_TITLE", "Yeni Kayıt")}</span>
          </Link>
        )}
      </div>

      <div id="collapseOne" className="accordion-collapse collapse page-header-collapse">
        <div className="accordion-body pb-2">
          <div className="row">
            <LeadsStatisticsTwo />
          </div>
        </div>
      </div>
    </>
  );
};

export default TestTypeHeader;
